function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56.21 0H9.37C4.22 0 0 4.22 0 9.37V67.92L11.71 56.21H56.21C61.41 56.21 65.58 52.04 65.58 46.84V9.37C65.58 4.22 61.41 0 56.21 0ZM32.79 49.84C32.79 49.84 9.37 34.57 9.37 19.44C9.37 10.87 16.77 7.68 20.66 7.68C28.76 7.68 32.79 13.86 32.79 13.86C32.79 13.86 36.87 7.68 44.97 7.68C48.86 7.68 56.21 10.87 56.21 19.44C56.21 34.57 32.79 49.84 32.79 49.84Z",
  fill: "white"
});
function SvgSocialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 68,
    viewBox: "0 0 66 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon);
export default __webpack_public_path__ + "static/media/Social Icon.213a261c708b11d9ebbd7d9409c97ae3.svg";
export { ForwardRef as ReactComponent };